export const translations = {
	common: {
		en: async () => import('./translations/en.json'),
		ru: async () => import('./translations/ru.json'),
	},
}
export const FALLBACK_LANGUAGE = 'ru'
export const DEFAULT_LANGUAGE = 'ru'

export type TranslationKeys = Awaited<
	ReturnType<typeof translations.common.ru>
>['default']

type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`

export type DotNotation<T> = (
	T extends object
		? {
				[K in keyof T]: K extends string
					? T[K] extends object
						? `${K}` | `${K}${DotPrefix<DotNotation<T[K]>>}`
						: never
					: never
		  }[keyof T]
		: never
) extends infer D
	? Extract<D, string>
	: never

export type TranslationPaths = DotNotation<TranslationKeys>

export {
	useTranslate,
	type TranslationFunction,
	type TranslationKey,
	type ColumnTranslationFunction,
} from './utils/useTranslate'
export {
	useTranslateInitializer,
	translate,
} from './utils/getTranslationFunction'
